















export default {
  name: 'controls'

  data: -> {
    'showControls': false
  }

  props: ['index', 'blockTypes']

  created: ->
    window.addEventListener('mouseup', this.closeControls)

  destroyed: ->
    window.removeEventListener('mouseup', this.closeControls)

  methods: {
    isChildOf: (parent, child) ->
      node = child.parentNode
      while node != null
        return true if node == parent
        node = node.parentNode
      return false

    toggleControls: ->
      this.showControls = !this.showControls

    closeControls: (e) ->
      this.showControls = false if this.$el != e.target && !this.isChildOf(this.$el, e.target)

    addBlock: (type) ->
      this.$emit('add-block', { blocktype: type, index: this.index })
      this.showControls = false
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Controls.vue